<template>
    <section class="section-padding" id="services">
        <div class="container-fluid container-lg">
            <div class="row justify-content-center align-items-center">
                <div class="col-12 text-center section-header">
                    <h2 class="mb-2">Services</h2>
                    <p>We have seamless number of services to convey your business</p>
                </div>
            </div>

            <div class="row justify-content-center align-items-center g-5 mt-3 mt-lg-4 px-md-5 px-lg-0" v-match-heights="{
    el: ['.service-box h3', '.service-box p'],  // Array of selectors to fix
  }">
                <div v-for="(service, index) in services" :key="index" class="col-11 col-md-6 col-lg-4">
                    <div class="service-box px-3 py-4 bg-white shadow-sm rounded">
                        <div class="service-box-icon mb-4">
                            <i :class="service.icon"></i>
                        </div>
                        <h3 class="mb-3">{{ service.title }}</h3>
                        <p>{{ service.description }}</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data(){
        return {
            services: [{
                icon: "fa fa-laptop-code",
                title: "Web Developement",
                description: "We build both mono lithics , decoupled web applications and APIs for any clients to consume"
            },
            {
                icon: "fa fa-palette",
                title: "UI/UX Design",
                description: "We prototype your website and get it a good visual design with great user experience",
            },
            {
                icon: "fa fa-mobile",
                title: "App Development",
                description: "We build cross-platform mobile application with consistent User Interface and Functionalities",
            },
            {
                icon: "fa fa-cog",
                title: "SEO Optimization",
                description: "We give your website a google SEO rank on SERP by writing SEO optimized codes for your website",
            },
            {
                icon: "fa fa-rocket",
                title: "Site Optimization",
                description: "We provide site speed ,accessibility and other important metrics optimization",
            },
            {
                icon: "fa fa-user-secret",
                title: "Training",
                description: "We provide both online and physical class on various aspects of software development, check our enrollment page",
            },
            ]
        }
    }
}
</script>

<style>
    #services h2 {
        font-size: 1.3rem;
        color: var(--dacode-primary-color);
    }

    .service-box-icon i{
        font-size: 2.5rem;
        color: var(--dacode-primary-color);
    }

    .service-box h3 {
        font-size: 1.1rem;
        color: var(--dacode-secondary-color);
    }

    .service-box p {
        opacity: .9;
    }

    .section-header p {
        font-size: .92rem;
    }

</style>